import React from "react";
import PageLayout from "./PageLayout";
import AudioSnippetListTable from "./AudioSnippetListTable";

const AudioSnippetsPage = () => {
  return (
    <PageLayout>
      <AudioSnippetListTable />
    </PageLayout>
  );
};

export default AudioSnippetsPage;

